import { toLocalIsoDate } from './format';

/** One CSV field, quoted when it holds a comma, a quote or a line break. Missing values are empty. */
const field = (value) => {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/**
 * Downloads rows as a CSV file named after the report and today's date, e.g.
 * downloadCsv('engagement', ['week_start', 'planners'], [['2026-08-03', 412]]) saves
 * engagement-2026-11-01.csv.
 *
 * @param {string} name - the file name before the date.
 * @param {Array<string>} header - column names.
 * @param {Array<Array>} rows - one array of values per line, in header order.
 */
export const downloadCsv = (name, header, rows) => {
  const lines = [header, ...rows].map((row) => row.map(field).join(','));
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${name}-${toLocalIsoDate(new Date())}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};
